module.exports = __webpack_public_path__ + "img/product6.d961f5ff.png";